import {ADD_SLEEVE} from "../constants/constants";

export const pushAddSleeveToSide =   (data) => {
    return {
        type : ADD_SLEEVE,
        payload : {
            ...data
        }
    };
};


// WEBPACK FOOTER //
// ./src/actions/pushAddSleeveToSide.js